import { captureException } from '@sentry/react'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { collections } from '@/schema'

const SearchParamsZod = z.object({
  central_id: z.number().optional(),
})

export const Route = createFileRoute('/promotions/$initiativeId/')({
  validateSearch: SearchParamsZod,
  beforeLoad: async ({ search, params }) => {
    if (!search.central_id) {
      throw redirect({ from: Route.fullPath, to: './national', replace: true })
    }
    const region = await collections.regions.findUniqueOrThrow({
      name: `region for central id ${search.central_id}`,
      where: [['piloteId', '==', search.central_id]],
    })
    const hasPlan = (region.promotionPlacements[params.initiativeId] ?? []).length > 0
    throw redirect({
      from: Route.fullPath,
      to: hasPlan ? './$regionId' : './$regionId/boutique',
      params: { regionId: region._id },
      replace: true,
    })
  },
  onCatch: (error) => {
    captureException(error, { tags: { route: Route.fullPath } })
  },
})
